import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';

import { RegularStorage, SecureStorage } from 'services/mmkv';

import bookmarks from './bookmarks/reducer';
import cast from './cast/reducer';
import config from './config/reducer';
import connection from './connection/reducer';
import details from './details/reducer';
import epg from './epg/reducer';
import errorDialog from './errorDialog/reducer';
import player from './player/reducer';
import programs from './programs/reducer';
import railsBuilder from './railsBuilder/reducer';
import recordings from './recordings/reducer';
import sentry from './sentry/reducer';
import sessions from './session/reducer';
import timer from './timer/reducer';
import user from './user/reducer';
import { injectReducer } from './utils';

export default combineReducers({
    user: persistReducer(
        {
            key: 'user',
            storage: SecureStorage,
            blacklist: [
                'modalVisible',
                'loginRequest',
                'favouriteChannelsListRequest',
                'changeUserProfileRequest',
                'language',
                'suspension',
                'entitlementsRequest',
                'pinsStatusRequest',
                'sharedConsentPublicId',
            ],
        },
        injectReducer(user.initialState, user.handlers),
    ),
    config: injectReducer(config.initialState, config.handlers),
    player: persistReducer(
        {
            key: 'player',
            storage: RegularStorage,
            whitelist: ['subtitles', 'audio', 'subtitlesFontSize'],
        },
        injectReducer(player.initialState, player.handlers),
    ),
    epg: persistReducer(
        {
            key: 'epg',
            storage: RegularStorage,
            whitelist: [
                'epgLastUpdated',
                'previouslyWatchedChannelByProfile',
                'epgSelectedLayout',
            ],
        },
        injectReducer(epg.initialState, epg.handlers),
    ),
    railsBuilder: injectReducer(
        railsBuilder.initialState,
        railsBuilder.handlers,
    ),
    programs: injectReducer(programs.initialState, programs.handlers),
    sessions: injectReducer(sessions.initialState, sessions.handlers),
    timer: injectReducer(timer.initialState, timer.handlers),
    errorDialog: injectReducer(errorDialog.initialState, errorDialog.handlers),
    details: injectReducer(details.initialState, details.handlers),
    recordings: persistReducer(
        {
            key: 'recordings',
            storage: RegularStorage,
            whitelist: ['deleteActionPinValidationTime'],
        },
        injectReducer(recordings.initialState, recordings.handlers),
    ),
    sentry: injectReducer(sentry.initialState, sentry.handlers),
    bookmarks: injectReducer(bookmarks.initialState, bookmarks.handlers),
    cast: injectReducer(cast.initialState, cast.handlers),
    connection: injectReducer(connection.initialState, connection.handlers),
});
